import { Reveal } from "./Reveal";

export const About = () => (
  <section className="relative mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36" data-testid="about-section">
    <div className="grid gap-12 lg:grid-cols-[0.4fr_0.6fr]">
      <Reveal>
        <p className="font-mono-num text-xs uppercase tracking-[0.3em] text-sky-400">What is Neyrein</p>
      </Reveal>
      <div>
        <Reveal delay={0.1}>
          <h2 className="font-serif-display text-2xl leading-snug tracking-tight text-slate-100 sm:text-3xl lg:text-4xl">
            Money feels loud. Neyrein makes it <em className="text-gradient-sky italic">quiet</em>.
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">
            Neyrein is a smart expense tracking and management app for mobile and PC. It records your
            expenses and income as they happen, keeps everything neatly categorized, and generates
            clear reports and statistics that show exactly where your money goes. When you want to go
            deeper, optional AI assistance spots patterns, flags unusual spending, and suggests
            calmer habits — never the other way around.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-10 grid grid-cols-3 gap-6 border-t border-sky-400/10 pt-8">
            {[
              ["2 taps", "to log any expense"],
              ["100%", "of your data, yours"],
              ["0 noise", "reports that stay simple"],
            ].map(([big, small]) => (
              <div key={big}>
                <p className="font-serif-display text-2xl text-sky-300 sm:text-3xl">{big}</p>
                <p className="mt-1 text-xs text-slate-500 sm:text-sm">{small}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
